import React, { useEffect, useState } from 'react';
import AddEnquiry from './AddEnquiry';
import { fetchEnquiryById } from '../../utils/enquiryApi';
import { getStorageValues } from '../../shared/CommonFunctions';

function EditEnquiry({ selectedRow, sendDataToParent, onLoanSummary, onRegisterLoanSummaryApply }) {
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const enquiryId = selectedRow?.EnquiryId;

  useEffect(() => {
    const load = async () => {
      if (!enquiryId) {
        setInitialValues(null);
        return;
      }
      setLoading(true);
      try {
        const result = await fetchEnquiryById({
          userId: getStorageValues('userId'),
          enquiryId
        });

        const header = result?.header || {};
        const details = result?.details || [];
        const mappedVehicleEnquiries = details.map((d) => {
          const vehicleLabel = d.VehicleLabel || '';
          return {
            id: d.EnquiryDetailsId,
            VehicleId: d.VehicleId,
            VehicleLabel: vehicleLabel,
            VehicleNameValue: vehicleLabel || d.VehicleId,
            VehicleColorValue: d.ColorId,
            VehicleCost: d.VehicleCost,
            PaymentTypeValue: d.PaymentType,
            DownPayment: d.DownPayment,
            EMITenure: d.EMITenure,
            EMIAmount: d.EMIAmount,
            ProcessingFees: d.ProcessingFees,
            PaymentType: d.PaymentType
          };
        });

        const payload = {
          EnquiryId: enquiryId,
          CustomerName: header.CustomerName || '',
          MobileNo: header.MobileNo || '',
          EnquirySource: header.EnquirySource ?? 'walking',
          EnquirySourceLabel: header.EnquirySourceLabel ?? '',
          ReferenceName: header.ReferenceName ?? '',
          Area: header.Area ?? '',
          VehicleEnquiries: mappedVehicleEnquiries
        };

        setInitialValues(payload);
        sendDataToParent(payload);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [enquiryId, sendDataToParent]);

  if (loading && !initialValues) {
    return <div className="p-2">Loading...</div>;
  }

  return (
    <AddEnquiry
      sendDataToParent={sendDataToParent}
      onLoad={() => {}}
      initialValues={initialValues}
      onLoanSummary={onLoanSummary}
      onRegisterLoanSummaryApply={onRegisterLoanSummaryApply}
    />
  );
}

export default EditEnquiry;